import React, { useState } from "react";
import Moment from "react-moment";
import Modal from "react-bootstrap/Modal";
import pin from "../../../../Assets/Images/pin.svg";
import send from "../../../../Assets/Images/send.svg";
import "./style.css";
import { getFileCategory, isValidString } from "../../../../helper";
import { cloudFileUpload, generatePresignedURL } from "../../../../redux/actions/cloudFileUpload";
import { useDispatch } from "react-redux";
import { getTicketList, postTicketAction } from "../../../../redux/actions/ticket";
import { Notify } from "notiflix";
import upload from './../../../../Assets/Images/cloud.svg'
import { ticketStateList } from "../../../../helper/general";

const CommentModal = ({ data, comments, show, handleClose, ticketModal }) => {

  const initFormData = {
    comment: "",
    actionType: "COMMENT"
  }

  const dispatch = useDispatch();

  const [formData, setFormData] = useState(initFormData);

  const handleInputChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  const handleFileChange = (event) => {
    const { files } = event.target;
    if (files?.length) {
      const fileType = files[0].name.split('.').pop();
      const Type = getFileCategory(fileType);
      dispatch(generatePresignedURL({ file_type: Type, upload_type: "TICKET" }, (url) => {
        dispatch(cloudFileUpload({ url, file: files[0] }, imageUrl => {
          setFormData({ ...formData, attachments: [{ fileType: Type, fileUrl: imageUrl }] })
        }))
      }))
    }
  }

  const handlePostComment = () => {
    const postData = { ...formData, ticketId: data?.ticketId };
    if (!isValidString(postData?.comment))
      return Notify.warning("please write a comment to post!")
    dispatch(postTicketAction(postData, () => {
      dispatch(getTicketList());
      setFormData(initFormData);
      handleClose();
    }));
  }

  const handleCancel = () => {
    setFormData(initFormData);
    handleClose();
  }


  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton className="border-0 cmnt-header">
        <Modal.Title className="modal-title title ticket-title fs-5 fw-bold mt-2">{data?.ticketDisplayId}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ticket-cmnt">
        <div className="row">
          <div className="col-md-3 col-sm-6 order-md-2 order-sm-1 text-sm-center text-md-end mb-3 mb-sm-0">
            <h6 className="fw-bold mb-3"><Moment format="DD MMM Y">{new Date(data?.ticketCreationTimestamp)}</Moment></h6>
            <span className={`cstm-pill ${data?.ticketStatus?.toLowerCase()}`}>{ticketStateList[data?.ticketStatus]}</span>
          </div>
          <div className="col-md-9 col-sm-6 order-md-1 order-sm-2">
            <p><strong>{data?.title}</strong></p>
            <p>{data?.description}</p>
          </div>
        </div>
        <p className="fw-bold mt-2">Conversation</p>
        {comments?.filter(item => ((item.actionType == "COMMENT" || item.actionType == "TICKET_CLOSED") && item?.visibleToCustomer))?.map?.((item, index) => {
          return (
            <div className={`${item?.actionCreatedBy == "CUSTOMER" ? 'right-commentbox float-end' : 'left-commentbox'} row rounded  my-3  px-4 py-3 col-lg-9`}>
              <p className="mb-4">{item?.comment}</p>
              <div className="d-flex justify-content-between">
                <div className="fw-semibold cmnt-desc">{item?.actionCreatedBy === "CUSTOMER" ? item?.actionUsername : 'Team KidEx'}, <Moment format="DD MMM Y">{new Date(item?.actionDate)}</Moment></div>
                {item?.attachments?.length > 0 && <div className="upload-icon"><a href={item?.attachments?.[0]?.fileUrl} target="_blank"><img src={pin} alt="pin" style={{ width: "1.3rem", height: "1.3rem" }} className="pin" /></a></div>}
              </div>
            </div>
          )
        })}
        {comments?.filter(item => ((item.actionType == "COMMENT" || item.actionType == "TICKET_CLOSED") && item?.visibleToCustomer))?.length === 0 && <p className="text-center">No previous conversations.</p>}
        {data?.ticketStatus != "CLOSED" &&
          <div className="message-outer">
            <div className="message">
              <textarea rows={1} type="text" name="comment" value={formData?.comment} onChange={handleInputChange} className="form-control py-3 comment-input mb-3 mt-5" placeholder="Write here" />
              <div className="send-box">
                <img onClick={handlePostComment} src={send} alt="send" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} className="send" />
                <div className="uploader contact-uploader comment-uploader">
                  <input type="file" onChange={handleFileChange} className="form-control rounded-0" id="inputGroupFile01" />
                  <div className="wrapp">
                    <div className="uploader-content">
                      <div className="upload-icon"><img src={pin} alt="pin" style={{ width: "1.3rem", height: "1.3rem" }} className="pin" /></div>
                    </div>
                  </div>
                  <div className="badge-upload">{formData?.attachments?.length ?? 0}</div>
                </div>
              </div>
            </div>
          </div>
        }
      </Modal.Body>
      {data?.ticketStatus != "CLOSED" &&
        <div className="row bottom-btn cmnt mb-4 justify-content-between mx-0 px-4">

          <div className="col-sm-12 col-lg-6">
            <div className="d-grid gap-2">
              <button className="btn btns btn-left" type="button" onClick={handleCancel}>Cancel</button>
            </div>
          </div>

          <div className="col-sm-12 col-lg-6 scnd-column">
            <div className="d-grid gap-2">
              <button className="btn btns btn-left" type="button" onClick={handlePostComment}>Submit</button>
              {/* <button className="btn btns btn-left" type="button" onClick={() => ticketModal(data)}>Close the ticket</button> */}
            </div>
          </div>
        </div>
      }
    </Modal>
  )
}

export default CommentModal;
